import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Search, CheckCircle } from 'lucide-react';

export const AuthenticityPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="authenticity-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="authenticity-title">Authenticity Policy</h1>
          <p className="text-lg text-softgrey">Every item we sell is genuine and carefully vetted.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-cream p-8 rounded-xl" data-testid="authentication-section">
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Our Guarantee</h2>
            </div>
            <p className="text-softgrey leading-relaxed">All items are:</p>
            <ul className="list-disc list-inside space-y-3 text-softgrey ml-2 mt-4">
              <li className="flex items-start gap-2">
                <Search className="w-5 h-5 text-coral mt-0.5 flex-shrink-0" />
                <span><strong>Hand-selected</strong> by our expert team with years of experience sourcing genuine vintage pieces</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-5 h-5 text-coral mt-0.5 flex-shrink-0" />
                <span><strong>Quality checked</strong> for materials, construction, labels, stitching, and period details</span>
              </li>
            </ul>
          </section>

          <section data-testid="counterfeit-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Our Commitment</h2>
            <p className="text-softgrey leading-relaxed">No counterfeit items knowingly sold. We do not knowingly sell counterfeit or misrepresented items. If you have any concerns about the authenticity of an item, please contact us directly.</p>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Have questions about an item? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link></p>
        </div>
      </div>
    </div>
  );
};
